import { createApi } from '@reduxjs/toolkit/query/react';
import { User, UserAvatar } from '../utils';
import baseQuery from '../../../baseQuery/basePharmaNavigatorQuery';
import { Product } from '../../products/api/types';

export const profileApi = createApi({
    reducerPath: 'profileApi',
    baseQuery,
    tagTypes: ['Profile', 'Avatar'],
    endpoints: (builder) => ({
        getProfile: builder.query<User, void>({
            query: () => ({
                url: `/api/v1/me`,
                method: 'GET',
            }),
            providesTags: ['Profile'],
        }),
        getAvatar: builder.query<UserAvatar, void>({
            query: () => ({
                url: `/api/v1/me/avatar`,
                method: 'GET',
            }),
            providesTags: ['Avatar'],
        }),
        updateProfile: builder.mutation<User, Partial<User>>({
            query: (profile) => ({
                url: `/api/v1/me`,
                method: 'PUT',
                body: profile,
            }),
            invalidatesTags: ['Profile'],
        }),
        updateAvatar: builder.mutation<{ fileLink: string }, FormData>({
            query: (image) => ({
                url: `/api/v1/me/avatar`,
                method: 'POST',
                body: image,
            }),
            invalidatesTags: ['Profile', 'Avatar'],
        }),
        updatePassword: builder.mutation<void, { newPassword: string }>({
            query: ({ newPassword }) => ({
                url: '/api/v1/me/change-password',
                method: 'PUT',
                body: { newPassword },
            }),
            invalidatesTags: ['Profile'],
        }),
        getUserProducts: builder.query<Array<Product>, void>({
            query: () => ({
                url: `/api/v1/me/products`,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useGetProfileQuery,
    useGetAvatarQuery,
    useUpdateProfileMutation,
    useUpdateAvatarMutation,
    useUpdatePasswordMutation,
    useGetUserProductsQuery,
} = profileApi;
